<template>
  <div style="display: flex;">
    <div>
      <span>Категорії товарів</span>
      <MenuNode :nodes="menuNodes" />
    </div>
    <div>
      <span>Інформаційні сторінки</span>
      <MenuNode2 :nodes="menuNodes" />
    </div>
  </div>
</template>

<script>
import MenuNode from '@/components/header/MenuNode2'
import MenuNode2 from '@/components/header/HeaderTop2'
import MenuMixin from '@/components/header/MenuMixin2'

export default {
  name: 'HeaderMenu',
  components: {
    MenuNode,
    MenuNode2,
  },
  mixins: [MenuMixin],
}
</script>
